import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'

const routes = (() => {
	const req = require.context('@/routes', true, /^((?!_).)*\.vue$/)
	return req.keys().map((filename) => {
		const route = req(filename).default
		const parts = filename.replace(".","").replace(/\.vue$/,"").split("/").filter(key => key !== 'index')
		route.routeConfig || (route.routeConfig = {})
		const path = route.routeConfig.path
		if(!_.startsWith(path, '/') && path !== '*') {
			const folderPath = _.initial(parts).join('/')
			const fileName = path || _.last(parts)
			route.routeConfig.path = `${folderPath}/${fileName}`
		}
		return Object.assign({
			name: _.camelCase(parts.join("_")),
			component: route
		}, route.routeConfig)
	})
})()

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: '',
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else if (to.params.preventScroll === true) {
			return null
		} else {
			return { x: 0, y: 0 }
		}
	}
})



// WEBPACK FOOTER //
// ./src/initializers/router.js